import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "event-card export-page" }
const _hoisted_2 = { class: "container-page big" }
const _hoisted_3 = {
  key: 0,
  class: "card-event__item"
}
const _hoisted_4 = { class: "card-event__item-value" }
const _hoisted_5 = { class: "card-event__item" }
const _hoisted_6 = { class: "card-event__item-value" }
const _hoisted_7 = { class: "card-event__item" }
const _hoisted_8 = { class: "card-event__item-value" }
const _hoisted_9 = { class: "card-event__item" }
const _hoisted_10 = { class: "card-event__item-value" }
const _hoisted_11 = { class: "card-event__item" }
const _hoisted_12 = { class: "card-event__item-value" }
const _hoisted_13 = { class: "card-event__item" }
const _hoisted_14 = { class: "card-event__item-value" }
const _hoisted_15 = { class: "card-event__item" }
const _hoisted_16 = { class: "card-event__item-value" }
const _hoisted_17 = { class: "card-event__item" }
const _hoisted_18 = { class: "card-event__item-value" }
const _hoisted_19 = {
  key: 1,
  class: "card-event__item"
}
const _hoisted_20 = { class: "card-event__item" }
const _hoisted_21 = { class: "card-event__item-value" }
const _hoisted_22 = { class: "card-event__item" }
const _hoisted_23 = { class: "card-event__item-value" }
const _hoisted_24 = { class: "card-event__item" }
const _hoisted_25 = { class: "card-event__item-value" }
const _hoisted_26 = { class: "card-event__item" }
const _hoisted_27 = { class: "card-event__item-value" }
const _hoisted_28 = { class: "card-event__item" }
const _hoisted_29 = { class: "card-event__item-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_CardEvent = _resolveComponent("CardEvent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      title: "Карточка мероприятия по ВЭС",
      mod: "mb-16"
    }, {
      button: _withCtx(() => [
        _createVNode(_component_ButtonComponent, {
          onClick: _ctx.downloadPDF,
          class: "event-card__export-button button-redesign--download-icon-fill button-redesign--mobile-full",
          disabled: _ctx.isExportProgress
        }, {
          default: _withCtx(() => [
            (!_ctx.isExportProgress)
              ? (_openBlock(), _createBlock(_component_IconComponent, {
                  key: 0,
                  name: "download-array"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.isExportProgress ? 'Загрузка...' : 'Скачать PDF'), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CardEvent, null, {
        default: _withCtx(() => [
          (!_ctx.isSystemEvent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "card-event__item-title" }, "Организатор", -1)),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.cardData.rfRegion || '-'), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "card-event__item-title" }, "Страны-партнеры мероприятия", -1)),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getPartnerCountries), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "card-event__item-title" }, "Даты проведения", -1)),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.getDatesRange), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "card-event__item-title" }, "Место проведения", -1)),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.cardData.eventLocation || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "card-event__item-title" }, "Наименование мероприятия", -1)),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.cardData.name || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "card-event__item-title" }, "Описание мероприятия", -1)),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.cardData.description || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "card-event__item-title" }, "Статус", -1)),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.getEventStatus), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "card-event__item-title" }, "Ключевая отрасль", -1)),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.cardData.mainIndustry || '-'), 1)
          ]),
          (!_ctx.isSystemEvent && _ctx.cardData.significantFlag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("p", { class: "card-event__item-title" }, "Значимое мероприятие", -1),
                _createElementVNode("p", { class: "card-event__item-value" }, "Да", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.isSystemEvent)
        ? (_openBlock(), _createBlock(_component_CardEvent, {
            key: 0,
            title: "Информация о заключенных соглашениях"
          }, {
            default: _withCtx(() => [
              (_ctx.cardData.ferAgreement && _ctx.cardData.ferAgreement.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.cardData.ferAgreement, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.id
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "card-event__item-title" }, "Страна-партнер соглашения", -1)),
                        _createElementVNode("p", _hoisted_21, _toDisplayString(item.partnerCountry?.name || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "card-event__item-title" }, "Описание соглашения", -1)),
                        _createElementVNode("p", _hoisted_23, _toDisplayString(item.description || '-'), 1)
                      ])
                    ], 64))
                  }), 128))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-event__item" }, [
                      _createElementVNode("p", { class: "card-event__item-title" }, "Страна-партнер соглашения"),
                      _createElementVNode("p", { class: "card-event__item-value" }, "-")
                    ], -1)),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-event__item" }, [
                      _createElementVNode("p", { class: "card-event__item-title" }, "Описание соглашения"),
                      _createElementVNode("p", { class: "card-event__item-value" }, "-")
                    ], -1))
                  ], 64))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_CardEvent, { title: "Участники мероприятия" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_24, [
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "card-event__item-title" }, "Российская делегация", -1)),
            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.cardData.russianDelegation || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "card-event__item-title" }, "Иностранная делегация", -1)),
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.cardData.foreignDelegation || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "card-event__item-title" }, "Контактное лицо", -1)),
            _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.cardData.contactPerson || '-'), 1)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}